import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

export type Props = {
  children?: any;
  className?: string;
  style?: any;
  Component?: any;
};

export const Paragraph = ({
  children,
  className,
  style,
  Component = 'div',
}: Props) => (
  <Component className={cx(styles.root, className)} style={style}>
    {children}
  </Component>
);
